import script from "./DirectPurchaseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectPurchaseForm.vue?vue&type=script&setup=true&lang=js"

import "./DirectPurchaseForm.vue?vue&type=style&index=0&id=5efb5e7a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5efb5e7a"]])

export default __exports__